import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { UPDATE_BATIMENT } from "../../Utils/constant";
import { updateOne } from "../../services/service";
import { useStoreBatiment } from "../../store/Paramettre/batimentStore";

export const UpdateTypeBatimentForm = ({ item }) => {
  const [designation, setDesignation] = useState("");

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const [isSubmit, setIsSubmit] = useState(false);
  const batiments = useStoreBatiment();

  const submit = (data) => {
    setIsSubmit(true);
    updateOne(UPDATE_BATIMENT, item?.id, data)
      .then((res) => {
        setIsSubmit(false);
        if (res.status === 200) {
          reset();
          batiments.batiments({ page: 0, param: "", size: 10 });
          toast.success("Type batiment mis à jour ");
          document.getElementById("updateBat").close();
        }
      })
      .catch((err) => {
        setIsSubmit(false);

        toast.error(err?.response?.data?.donnee);
      });
  };
  useEffect(() => {
    if (item) {
      reset();
    }
  }, [item, reset]);

  useEffect(() => {
    setDesignation(item?.designation);
  }, [item]);

  return (
    <form onSubmit={handleSubmit(submit)} className="px-2">
      <div className="my-4 space-y-4">
        <div className="my-2">
          <label htmlFor="" className="">
            Designation
          </label>
          <input
            {...register("designation", { required: true })}
            value={designation}
            onChange={(e) => setDesignation(e.target.value)}
            className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
          />
          {errors.designation && (
            <span className="text-sm text-rose-600">
              Ce champs est obligatoire
            </span>
          )}
        </div>

        <button
          type="submit"
          disabled={isSubmit ? true : false}
          className={`${
            !isSubmit ? "text-black bg-main" : "text-slate-800 bg-slate-200 "
          } w-full my-3 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-bold rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800`}
        >
          {!isSubmit ? "Enregistrer" : "Veuillez patientez..."}{" "}
          {isSubmit ? (
            <span className="loading loading-dots loading-xs"></span>
          ) : null}
        </button>
      </div>
    </form>
  );
};
